<template>
  <div>
    <el-container
      style="
        overflow: hidden;
        min-width: 1600px;
        padding-left: 20px;
        padding-right: 20px;
      "
    >
      <div style="float: left; width: 20%; white-space: nowrap">
        <el-form inline @submit.native.prevent style="width: 100%">
          <el-form-item
            label="收货单号"
            style="width: 100%"
            class="signForNoItem"
          >
            <el-input
              style="width: 100%"
              v-model.trim="signForNumber"
              placeholder="请输入收货单号"
              clearable
              @keyup.enter.native="initTable"
              ref="signForRef"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="buttonDiv" style="float: left; width: 50%; margin-left: 2%">
        <toolbar
          :buttonList="buttonList"
          @callFunction="callFunction"
        ></toolbar>

        <!-- <el-button type="primary" @click="initTable">查询</el-button> -->

        <!-- <el-button type="primary" @click="importExport">导入</el-button> -->
      </div>
    </el-container>

    <el-container>
      <el-main>
        <div>
          <!-- left sidebar -->
          <div class="left-item">
            <el-card class="box-card" style="width: 100%">
              <div slot="header" class="clearfix">
                <span>待收货上架</span>
              </div>
              <div class="left-item-card">
                <div style="width: 99%">
                  <template v-if="shartSearch">
                    <el-card
                      class="box-card"
                      style="width: 100%; background-color: rgba(0, 0, 0, 0.1)"
                    >
                      <div
                        class="text item"
                        style="text-align: center; color: #909399"
                      >
                        <i class="el-icon-loading"></i>搜索中...
                      </div>
                    </el-card>
                  </template>
                  <template v-else>
                    <template>
                      <el-card
                        class="box-card"
                        style="
                          margin-bottom: 10px;
                          cursor: pointer;
                          width: 100%;
                          background-color: #c5c7cc;
                        "
                      >
                        <div class="text item">
                          <div>收货单号：{{ WaitPickList.signForNumber }}</div>
                          <div>进仓单号：{{ WaitPickList.deliveryOrdeNo }}</div>
                          <div>参考单号：{{ WaitPickList.orgCustomerNo }}</div>
                          <div>仓库：{{ WaitPickList.warehouseName }}</div>
                          <div>目的地：{{ WaitPickList.destination }}</div>
                          <div>签收箱数：{{ WaitPickList.actualBoxCount }}</div>
                          <div>
                            过机箱数：{{ WaitPickList.machineBoxCount }}
                          </div>
                          <div>
                            已扫描箱数：{{ WaitPickList.scanningBoxCount }}
                          </div>
                        </div>
                      </el-card>
                    </template>
                  </template>
                </div>
              </div>
            </el-card>
          </div>

          <!-- right table -->
          <div
            style="float: left; margin-left: 2%; width: 78%"
            class="otherTable"
          >
            <div>
              <el-form ref="form" :inline="true" label-width="80px">
                <el-row>
                  <el-col>
                    <el-form-item
                      label="库位"
                      class="noMarginBot"
                      prop="LocationCode"
                    >
                      <el-select
                        v-model="filters.locationCode"
                        style="width: 100%"
                        placeholder="请选择库位"
                        multiple
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in locationList"
                          :label="item.locationCode"
                          :value="item.locationCode"
                          :key="item.locationCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="生成分货码"
                      prop="resource"
                      label-width="140px"
                    >
                      <el-radio-group v-model="filters.resource">
                        <el-radio label="true">是</el-radio>
                        <el-radio label="false">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="托盘" class="labelcall">
                      <el-input
                        min="0"
                        auto-complete="off"
                        placeholder="整箱托"
                        style="width: 120px; float: left"
                        type="number"
                        v-model="filters.palletQty"
                      ></el-input>

                      <el-input
                        min="0"
                        auto-complete="off"
                        placeholder="箱数"
                        type="number"
                        style="width: 120px; float: left"
                        v-model="filters.boxQty"
                      ></el-input>

                      <el-input
                        min="0"
                        auto-complete="off"
                        placeholder="尾箱托"
                        type="number"
                        style="width: 120px; float: left"
                        v-model="filters.tailBoxQty"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div style="display: flex">
                  <div>
                    <div
                      class="boxRow"
                      v-for="(filtersItem, index) in filtersArr"
                      :key="index"
                    >
                      <el-row class="boxFirstRow">
                        <el-col>
                          <el-form-item
                            label="箱规"
                            prop="OrgReceiptNo"
                            class="labelcall"
                          >
                            <el-input
                              min="0"
                              auto-complete="off"
                              placeholder="长（cm）"
                              style="width: 120px; float: left"
                              type="number"
                              v-model="filtersItem.boxLength"
                              @input="
                                filtersItem.boxLength =
                                  filtersItem.boxLength.replace(/[^0-9.]/g, '')
                              "
                            ></el-input>

                            <el-input
                              min="0"
                              auto-complete="off"
                              placeholder="宽（cm）"
                              type="number"
                              style="width: 120px; float: left"
                              v-model="filtersItem.boxWidth"
                              @input="
                                filtersItem.boxWidth =
                                  filtersItem.boxWidth.replace(/[^0-9.]/g, '')
                              "
                            ></el-input>

                            <el-input
                              min="0"
                              auto-complete="off"
                              placeholder="高（cm）"
                              type="number"
                              style="width: 120px; float: left"
                              v-model="filtersItem.boxHeight"
                              @input="
                                filtersItem.boxHeight =
                                  filtersItem.boxHeight.replace(/[^0-9.]/g, '')
                              "
                            ></el-input>
                          </el-form-item>

                          <el-form-item
                            label="毛重"
                            class="labelcall"
                            label-width="120px"
                          >
                            <el-input
                              min="0"
                              auto-complete="off"
                              placeholder="毛重（kg）"
                              style="width: 120px"
                              type="number"
                              v-model="filtersItem.boxWeight"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row class="boxLastRow">
                        <el-col>
                          <el-form-item label="扫码收货">
                            <el-input
                              v-model.trim="filtersItem.scanBoxCode"
                              placeholder="请扫描箱子箱唛信息"
                              clearable
                              @keyup.enter.native="getBoxCode(index)"
                              :disabled="filtersItem.disabled"
                              :ref="'scanBoxRef' + index"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-link
                          v-if="filtersArr && filtersArr.length > 1"
                          class="removeLink"
                          :underline="false"
                          type="primary"
                          @click.native="removeBox(index)"
                        >
                          删除
                        </el-link>
                      </el-row>
                    </div>
                  </div>

                  <el-link
                    class="addLink"
                    :underline="false"
                    type="primary"
                    @click.native="addBox"
                  >
                    继续添加
                  </el-link>
                </div>
              </el-form>
            </div>
            <el-row type="flex" class="row-bg">
              <span class="errorMsg">
                {{ scanBoxCodeErrorMsg }}
              </span>
            </el-row>
            <div class="all-clear">
              <el-table-bar :fixed="false" :bottom="35">
                <el-table
                  class="cancelFixedTop"
                  border
                  :data="tableData"
                  style="width: 100%"
                  v-loading="listLoading"
                  @selection-change="handleRowSelect"
                  @row-click="handleRowClick"
                  ref="multipleTable"
                >
                  <el-table-column
                    prop="customerBox"
                    label="箱号"
                    min-width="130"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="declareCName"
                    label="中文申报名称"
                    min-width="150"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="electricity"
                    label="是否含电"
                    min-width="100"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="boxWeight"
                    label="毛重(kg)"
                    min-width="100"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="boxVolume"
                    label="体积(cbm)"
                    min-width="100"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="boxLength"
                    label="长(cm)"
                    min-width="100"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="boxWidth"
                    label="宽(cm)"
                    min-width="100"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="boxHeight"
                    label="高(cm)"
                    min-width="100"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column label="操作" min-width="100" align="center">
                    <template slot-scope="scope">
                      <el-button
                        v-show="scope.row.actualEntryDataId == 0"
                        @click="delboxMark(scope.row)"
                        type="text"
                        size="small"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-table-bar>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
    <!-- 上传收货信息 -->
    <el-dialog
      :visible.sync="importVisible"
      v-model="importVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="上传收货信息"
      width="40%"
      style="text-align: center"
    >
      <el-form>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              ref="upload"
              class="upload-demo"
              drag
              action="string"
              :http-request="UploadExcel"
              :limit="1"
              accept=".xls,.xlsx"
              :before-upload="onBeforeUploadExcel"
              :auto-upload="false"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传.xls,.xlsx文件
              </div>
            </el-upload>
          </el-form-item>
        </el-row>
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item v-if="WaitPickList.machineBoxCount == 0">
            <el-button type="info" @click="handleDownload">下载模板</el-button>
          </el-form-item>
          <el-form-item
            style="margin-left: 40px"
            v-if="WaitPickList.machineBoxCount > 0"
          >
            <el-button type="success" @click="handleMachine"
              >下载过机未匹配数据</el-button
            >
          </el-form-item>
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="submitUpload">确认上传</el-button>
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div style="color: red">{{ Importtext }}</div>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 收货照片 -->
    <el-dialog
      append-to-body
      title="完成收货"
      :visible.sync="showPhotoModel"
      @close="close"
      :center="true"
    >
      <div style="font-size: 15px; font-weight: 600; margin-bottom: 10px">
        签收{{ WaitPickList.actualBoxCount || 0 }}箱，扫描{{
          WaitPickList.scanningBoxCount || 0
        }}箱。
      </div>
      <div class="demo-image">
        <ul v-for="(item, i) in photoList" :key="i">
          <div v-for="(item2, i2) in item" :key="i2" class="image-box">
            <p>
              <span style="color: red" v-if="item2.required">*</span
              >{{ item2.text }}
            </p>
            <div
              class="sign-photo-item"
              v-if="imgObj[item2.name]"
              @mouseover="imgMouseOver(i, i2)"
              @mouseleave="imgMouseLeave(i, i2)"
            >
              <div class="del-box" v-if="item2.showControl">
                <i
                  class="el-icon-zoom-in"
                  style="margin-right: 10px"
                  @click="showImg(imgObj[item2.name])"
                ></i>
                <i class="el-icon-delete" @click="deleteImg(item2.name)"></i>
              </div>
              <div class="loading-box" v-if="item2.loading">
                <i class="el-icon-loading"></i>
              </div>
              <img
                :src="imgObj[item2.name]"
                class="sign-photo-item-img"
                alt=""
              />
            </div>

            <div class="sign-photo-btn" v-else>
              <div class="photo">
                <input
                  class="img hidden"
                  @change="changeImg(i, i2)"
                  type="file"
                  name="cover"
                  ref="inputer"
                  accept="image/*"
                />
                <p @click="chooseImage(item2.id)" class="photo-s">
                  <i class="el-icon-picture-outline"></i>
                </p>
              </div>
            </div>
          </div>
        </ul>

        <el-dialog
          :visible.sync="dialogVisible"
          width="60%"
          :modal="false"
          :center="true"
          append-to-body
          custom-class="imgPreview"
        >
          <img height="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确认收货</el-button>
        <el-button @click="showPhotoModel = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTFSignForTaskcBySignForNumber,
  syncMachineData,
  insertTFInventoryInfo,
  deleteTFSignForBox,
  importTFSignForBox,
  exportDeliveryBoxInfoOut,
  exportDeliveryBoxInfoMachine,
} from "@/api/transfer/tfSignFor/signInScanning.js";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";
import { thereAre } from "util/util";
import axios from "axios";
import { BaseApiUrl } from "@/api/axios_config";
export default {
  components: { Toolbar },
  data() {
    return {
      scanBoxCodeErrorMsg: "",
      filters: {
        resource: "false",
      },
      filtersArr: [{}],
      signForNumber: "",
      buttonList: [],
      listLoading: false,
      tableData: [],
      boxList: [],
      locationList: [],
      WaitPickList: {},
      selectRows: [],
      shartSearch: false,
      isSuccess: false,
      palletFileUrl: "",
      //导入收货箱文件
      progressFlag: false, //进度条初始值隐藏
      progressPercent: 0, //进度条初始值
      Importtext: "", //导入返回信息
      importVisible: false,
      //上传收货照片
      dialogVisible: false,
      dialogImageUrl: "",
      showPhotoModel: false,
      imgObj: {
        // 图片类型 1.车牌照 2.空柜照 3.托运单 4.未关门照 5.半关门照 6关门照 7.锁封照 8.其他 9.其他1
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        img6: "",
        img7: "",
        img8: "",
        img9: "",
      },
      isAuthorize:false,
      photoList: [
        [
          {
            name: "img1",
            text: "其他",
            id: 1,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img2",
            text: "其他1",
            id: 2,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img3",
            text: "其他2",
            id: 3,
            showControl: false,
            loading: false,
            required: false,
          },
        ],
        [
          {
            name: "img4",
            text: "其他3",
            id: 4,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img5",
            text: "其他4",
            id: 5,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img6",
            text: "其他5",
            id: 6,
            showControl: false,
            loading: false,
            required: false,
          },
        ],
        [
          {
            name: "img7",
            text: "其他6",
            id: 7,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img8",
            text: "其他7",
            id: 8,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img9",
            text: "其他8",
            id: 9,
            showControl: false,
            loading: false,
            required: false,
          },
        ],
      ],
      imgFiles: [],
      saveImgUrlArr: [],
    };
  },
  methods: {
    addBox() {
      this.filtersArr.push({});
    },
    removeBox(index) {
      this.filtersArr.splice(index, 1);
    },
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    initTable() {
      if (this.signForNumber === "" || this.signForNumber === null) {
        this.$message({
          message: "收货单号不能为空！",
          type: "error",
        });

        return;
      }
      this.$refs.signForRef.select();
      this.shartSearch = true;
      getTFSignForTaskcBySignForNumber({
        signForNumber: this.signForNumber,
      }).then((res) => {
        this.shartSearch = false;
        this.tableData = [];
        if (res.data.success) {
          this.WaitPickList = res.data.response;
          //this.tableData = res.data.response.signForBoxList;
          this.boxList = res.data.response.boxList;
          this.locationList = res.data.response.locationList;
          this.filters.resource =
            this.WaitPickList.destinationType === 2 ? "true" : "false";
          this.isSuccess = false;
          this.palletFileUrl = "";
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
          this.WaitPickList = {};

          this.locationList = [];
        }
      });
    },
    MachineSync() {
      if (!this.WaitPickList.signForNumber) {
        this.$message({
          message: "请先查询收货单",
          type: "error",
        });
        return;
      }

      if (this.WaitPickList.machineBoxCount === 0) {
        this.$message({
          message: "过机箱数为0,同步失败",
          type: "error",
        });

        return;
      }
      let loading = this.$loading({
        lock: true,
        text: "同步中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      syncMachineData({
        TFSignForID: this.WaitPickList.tfSignForID,
      }).then((res) => {
        loading.close();
        if (res.data.success) {
          this.tableData = res.data.response;
          if (res.data.response.length > 0) {
            this.$set(
              this.WaitPickList,
              "scanningBoxCount",
              res.data.response[0].scanningBoxCount
            );
          }
          this.$message({
            message: "同步成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //扫码
    getBoxCode(index) {
      //  选择
      this.$refs["scanBoxRef" + index][0].select();
      // index为当前行下标
      const that = this;

      if (!that.WaitPickList.signForNumber) {
        this.$message({
          message: "请先查询收货单",
          type: "error",
        });
        return;
      }
      if (this.WaitPickList.machineBoxCount > 0) {
        //有过机数据但没权限，则只允许操作同步
        if (!this.isAuthorize) {
          this.$message({
            message: "存在过机数据且无跳过权限，请先同步",
            type: "error",
          });
          return;
        }
      }
      let nowFilters = this.filtersArr[index];
      if (!nowFilters.scanBoxCode) return;

      if (
        !nowFilters.boxLength ||
        !nowFilters.boxWidth ||
        !nowFilters.boxHeight
      ) {
        this.$message({
          message: "箱规请填写完整！",
          type: "error",
        });

        return;
      }
      if (!nowFilters.boxWeight) {
        this.$message({
          message: "毛重不能为空！",
          type: "error",
        });

        return;
      }
      this.$set(this.filtersArr[index], "disabled", true);

      var scanning = this.tableData.filter((m) => {
        return m.customerBox === nowFilters.scanBoxCode;
      });
      if (scanning.length > 0) {
        this.scanBoxCodeErrorMsg = `失败,箱号【${nowFilters.scanBoxCode}】已扫描`;
        nowFilters.scanBoxCode = "";
      } else {
        var scanningList = this.boxList.filter((m) => {
          return m.customerBox === nowFilters.scanBoxCode;
        });

        if (scanningList === null || scanningList.length === 0) {
          this.scanBoxCodeErrorMsg = `失败,未查询到箱号`;
          nowFilters.scanBoxCode = "";
        } else {
          this.scanBoxCodeErrorMsg = `箱号【${nowFilters.scanBoxCode}】成功!`;
          console.log(scanningList);
          nowFilters.scanBoxCode = "";
          scanningList.forEach((item, index) => {
            item.boxWeight = nowFilters.boxWeight;
            item.boxLength = nowFilters.boxLength;
            item.boxWidth = nowFilters.boxWidth;
            item.boxHeight = nowFilters.boxHeight;
            item.actualEntryDataId = 0;
            that.tableData.push(item);
          });
          that.$set(
            that.WaitPickList,
            "scanningBoxCount",
            that.tableData.length
          );
        }
      }
      this.$set(this.filtersArr[index], "disabled", false);
      this.$nextTick(() => {
        this.$refs["scanBoxRef" + index][0].focus();
      });
      //暂不使用rides
      //   scanningTFSignForBox({
      //   CustomerBox: nowFilters.scanBoxCode,
      //   SignForNumber: that.WaitPickList.signForNumber,
      //   BoxWeight: nowFilters.boxWeight,
      //   BoxLength: nowFilters.boxLength,
      //   BoxWidth: nowFilters.boxWidth,
      //   BoxHeight: nowFilters.boxHeight,
      // }).then((res) => {
      //   if (res.data.success) {
      //     //  this.getDetail()

      //     this.scanBoxCodeErrorMsg = `箱号【${nowFilters.scanBoxCode}】成功!`;
      //     that.$set(
      //       that.WaitPickList,
      //       "scanningBoxCount",
      //       res.data.response[0].scanningBoxCount
      //     );
      //     nowFilters.scanBoxCode = "";
      //     console.log(that.tableData);
      //     if (that.tableData === null || that.tableData.length === 0) {
      //       that.tableData = res.data.response;
      //     } else {
      //       res.data.response.forEach((item, index) => {
      //         that.tableData.push(item);
      //       });
      //     }
      //   } else {
      //     this.scanBoxCodeErrorMsg = `失败,${res.data.msg}`;
      //     nowFilters.scanBoxCode = "";
      //   }
      //   this.$set(
      //     this.filtersArr[index],
      //     'disabled',
      //     false
      //   )
      //   this.$nextTick(()=>{
      //     this.$refs['scanBoxRef' + index][0].focus()
      //   })
      // })
    },
    //删除箱唛
    delboxMark(row) {
      const that = this;

      if (!that.WaitPickList.signForNumber) {
        this.$message({
          message: "请先查询收货单",
          type: "error",
        });
        return;
      }

      this.$confirm("确认删除箱号" + row.customerBox + "吗?", "提示", {}).then(
        () => {
          //删除箱明细
          for (var j = 0; j < this.tableData.length; j++) {
            const delindex = this.tableData.findIndex(
              (item) => item.tfDeliveryBoxInfoID === row.tfDeliveryBoxInfoID
            );
            if (delindex > -1) {
              this.tableData.splice(delindex, 1);
              j--;
            } else break;
          }

          that.$set(
            that.WaitPickList,
            "scanningBoxCount",
            this.tableData.length
          );
          //暂时不用rides
          //    deleteTFSignForBox ({
          //        signForNumber: that.WaitPickList.signForNumber,
          //        tfDeliveryBoxInfoID: row.tfDeliveryBoxInfoID,

          // }).then((res) => {
          //   if (res.data.success) {

          //     //删除箱明细
          //     for (var j = 0; j < this.tableData.length; j++) {
          //       const delindex = this.tableData.findIndex(
          //         (item) =>
          //           item.tfDeliveryBoxInfoID ===row.tfDeliveryBoxInfoID
          //         );
          //       if (delindex > -1) {
          //         this.tableData.splice(delindex, 1);
          //         j--;
          //       } else break;
          //     };

          //     that.$set(
          //       that.WaitPickList,
          //       "scanningBoxCount",
          //       res.data.msg*1
          //     );

          //   } else {

          //    this.$message({
          //     message: res.data.msg,
          //     type: "error",
          //   });
          //   }
          //  });
        }
      );
    },

    inventoryInfo() {
      const that = this;

      if (!that.WaitPickList.signForNumber) {
        this.$message({
          message: "请先查询收货单",
          type: "error",
        });
        return;
      }

      if (this.tableData === null || this.tableData.length === 0) {
        this.$message({
          message: "请扫描箱唛",
          type: "error",
        });

        return;
      }

      var msg = "订单已清点完成，确认收货吗？";
      if (
        that.WaitPickList.scanningBoxCount != that.WaitPickList.actualBoxCount
      ) {
        msg = "签收箱数与清点箱数不一致，确认收货吗？";
      }

      this.$confirm(msg, "提示", {})
        .then(() => {
          this.showPhotoModel = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    printBoxMark() {
      const that = this;

      if (!that.isSuccess) {
        this.$message({
          message: "请先完成收货",
          type: "error",
        });
        return;
      }
      if (this.palletFileUrl === "") {
        this.$message({
          message: "托唛生成异常,请联系IT",
          type: "error",
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      window.open(that.palletFileUrl, "_blank");

      loading.close();
    },
    submit() {
      const that = this;
      // 图片正在上传中
      let loading;
      if (this.uploadImgIng) {
        this.clickSubmit = true;
        this.loading = this.$loading({
          lock: true,
          text: "操作中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.5)",
        });
        return;
      } else if (this.loading) {
        this.loading.close();
      }

      if (!that.WaitPickList.signForNumber) {
        this.$message({
          message: "请先查询收货单",
          type: "error",
        });
        return;
      }

      if (this.tableData === null || this.tableData.length === 0) {
        this.$message({
          message: "请扫描或导入箱子信息",
          type: "error",
        });

        return;
      }

      loading = this.$loading({
        lock: true,
        text: "收货中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      insertTFInventoryInfo({
        LocationCode: thereAre(that.filters.locationCode),
        SignForNumber: that.WaitPickList.signForNumber,
        SignForBoxList: that.tableData,
        Resource: that.filters.resource,
        TFSignForID: that.WaitPickList.tfSignForID,
        imageUrls: this.saveImgUrlArr,
        PattleList: [
          {
            PalletQty: that.filters.palletQty,
            BoxQty: that.filters.boxQty,
            TailBoxQty: that.filters.tailBoxQty,
          },
        ],
      }).then((res) => {
        loading.close();
        if (res.data.success) {
          this.showPhotoModel = false;
          this.isSuccess = true;
          this.palletFileUrl = res.data.msg;
          this.palletQty = "";
          this.boxQty = "";
          this.tailBoxQty = "";
          this.WaitPickList = {};
          this.tableData = [];
          this.locationList = [];
          this.saveImgUrlArr = [];
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    handleRowClick(row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    handleRowSelect(rows) {
      this.selectRows = rows;
    },

    //弹出导入文件框
    importExport() {
      const that = this;

      if (!that.WaitPickList.signForNumber) {
        this.$message({
          message: "请先查询收货单",
          type: "error",
        });
        return;
      }

      this.Importtext = "";

      if (
        this.WaitPickList.machineBoxCount > 0 &&
        this.WaitPickList.machineBoxCount == this.WaitPickList.actualBoxCount
      ) {
        this.$message({
          message: "过机箱数与签收箱收一致，请直接同步后确认收货，无须导入",
          type: "error",
        });
        return;
      }
      if (this.WaitPickList.machineBoxCount > 0 ) {
        //有过机数据但没权限，则只允许操作同步
        if (!this.isAuthorize) {
          this.$message({
            message: "存在过机数据且无跳过权限，请先同步",
            type: "error",
          });
          return;
        }
      }

      this.importVisible = true;
    },
    //文件上传前验证
    onBeforeUploadExcel(file) {
      console.log(file);
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      // const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: "导入文件只能是 xls、xlsx格式!",
          type: "error",
        });
      }
      return extension || extension2;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },

    //上传文件
    UploadExcel(param) {
      if (param == undefined) {
        this.$message({
          message: "请上传导入文件",
          type: "error",
        });
        return;
      }

      this.parafile = param;
      let para = new FormData();
      para.append("file", param.file);
      this.progressFlag = true;
      axios({
        url:
          importTFSignForBox +
          "?signForNumber=" +
          this.WaitPickList.signForNumber,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          this.type = 1;
          this.Importtext = res.data.msg;
          console.log(this.Importtext);
          if (res.data.success) {
            this.tableData = res.data.response;
            this.parafile = "";
            param.onError(); // 上传成功的文件会显示绿色的对勾
            this.importVisible = false;
            if (res.data.response.length > 0) {
              this.$set(
                this.WaitPickList,
                "scanningBoxCount",
                res.data.response[0].scanningBoxCount
              );
            }

            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
            param.onError();
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          param.onError();
        });
    },
    //下载模板
    handleDownload() {
      const that = this;
      if (!that.WaitPickList.signForNumber) {
        this.$message({
          message: "请先查询收货单",
          type: "error",
        });
        return;
      }
      let pata = { signForNumber: that.WaitPickList.signForNumber };
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(exportDeliveryBoxInfoOut, {
          params: pata,
        })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //下载机测数据
    handleMachine() {
      const that = this;
      if (!that.WaitPickList.signForNumber) {
        this.$message({
          message: "请先查询收货单",
          type: "error",
        });
        return;
      }
      let pata = { signForNumber: that.WaitPickList.signForNumber };
      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(exportDeliveryBoxInfoMachine, {
          params: pata,
        })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    clearImgModel() {
      this.imgObj = {
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        img6: "",
        img7: "",
        img8: "",
        img9: "",
      };

      this.saveImgUrlArr = [];
    },
    close() {
      this.clearImgModel();
      this.showPhotoModel = false;
    },

    imgMouseOver(i, i2) {
      this.$set(this.photoList[i][i2], "showControl", true);
    },

    imgMouseLeave(i, i2) {
      this.$set(this.photoList[i][i2], "showControl", false);
    },
    deleteImg(type) {
      this.$set(this.imgObj, type, "");

      this.saveImgUrlArr.forEach((item, i) => {
        const m = type.split("")[3];
        if (m == item.imageType) {
          this.saveImgUrlArr.splice(i, 1);
        }
      });
    },

    showImg(base64Url) {
      this.dialogVisible = true;
      this.dialogImageUrl = base64Url;
    },

    changeImg(i, i2) {
      const img = document.getElementsByClassName("img")[0];

      if (!img.files.length) return;

      this.handleFiles(img.files);

      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.toUpload(i, i2);
    },

    chooseImage(num) {
      console.log("num=", num);
      this.currentImg = num;
      document.getElementsByClassName("img")[0].value = "";
      document.getElementsByClassName("img")[0].click();
    },

    handleFiles(files) {
      const that = this;

      var file = files;

      const { type, name } = file[0];

      var imageType = /^image\//;
      if (!imageType.test(type)) {
        return;
      }

      var reader = new FileReader();
      reader.onload = function (e) {
        that.$set(that.imgObj, `img${that.currentImg}`, e.target.result);
      };
      reader.readAsDataURL(file[0]);
    },

    toUpload(i, i2) {
      const that = this;
      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      const s = this.currentImg;
      this.$set(this.photoList[i][i2], "loading", true);
      this.uploadImgIng = true;
      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        this.uploadImgIng = false;
        this.$set(this.photoList[i][i2], "loading", false);
        if (res.data.status === 200 && res.data.success) {
          console.log("this.currentImg=", this.currentImg);
          this.saveImgUrlArr.push({
            imageUrl: res.data.response[0].urlPath,
            imageType: s,
          });
          this.imgFiles = [];
          if (this.clickSubmit) {
            this.$nextTick(() => {
              this.clickSubmit = false;
              this.submit();
            });
          }
        } else {
          this.$message({
            message: "图片上传失败，请重试",
            type: "error",
          });
        }
      });
    },
    receiptTo() {
      const { query } = this.$route;
      if (query.signForNumber && query.signForNumber !== this.signForNumber) {
        this.signForNumber = query.signForNumber;
        this.$nextTick(() => {
          this.initTable();
        });
      }
    },
  },
  watch: {
    $route(to, from) {
      this.receiptTo();
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.isAuthorize = this.buttonList.some(entity => entity.name === '过机修改收货');
    console.info(this.isAuthorize);
    this.receiptTo();
  },
};
</script>

<style scoped lang="less">
.left-item {
  float: left;
  width: 20%;
  // min-width: 285px;
}
.left-item-card {
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;
}

.left-item-card {
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(207, 210, 217);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgb(184, 182, 182);
  }
}
.signForNoItem {
  display: flex;
  margin-bottom: 0;
  ::v-deep .el-form-item__content {
    flex: 1;
  }
}
.buttonDiv {
  ::v-deep .el-form--inline .el-form-item {
    margin-bottom: 0;
  }
}
.boxRow {
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  padding: 15px 10px;
  margin: 10px 0;
  .boxLastRow {
    display: flex;
    .removeLink {
      margin-right: 10px;
      white-space: nowrap;
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .boxFirstRow {
    .el-input {
      margin-right: 2px;
    }
  }
}
.noMarginBot {
  margin-bottom: 10px;
}

.all-status {
  /* text-align: end; */
  height: 43px;
  padding-top: 15px;
  float: left;
}

.all-right {
  text-align: end;
  height: 43px;
  padding-top: 15px;
  float: left;
  margin-right: 10px;
  margin-left: 200px;
}

.all-clear {
  clear: both;
}

.hide .el-upload--picture-card {
  display: none;
}
.addLink {
  align-self: flex-end;
  padding-bottom: 10px;
  white-space: nowrap;
  margin-left: 10px;
}
.errorMsg {
  color: red;
  text-align: center;
  width: 50%;
}
.image-box {
  float: left;
  width: 20%;
  text-align: center;
}
.sign-photo-btn {
  width: 100px;
  border: 1px dashed #ccc;
  margin: 0 auto;
  height: 100px;
  cursor: pointer;
}
.sign-photo-btn:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.sign-photo-item:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.photo-s {
  color: #bfbfbf;
  padding: 23px 0;
  margin: 0;
  i {
    font-size: 55px;
  }
}
.sign-photo-item {
  height: 100px;
  width: 100px;
  margin: 0 auto;
  position: relative;
  img {
    height: 100px;
    width: 100px;
  }
}
.del-box {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    cursor: pointer;
    color: rgb(248, 248, 248);
    margin-top: 35px;
  }
}
.loading-box {
  background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    color: rgb(224, 222, 222);
    margin-top: 35px;
  }
}
.hidden {
  display: none;
}
.demo-image {
  max-height: 500px;
  overflow: auto;
  > ul {
    display: flex;
    justify-content: space-around;
  }
}

.imgPreview {
  height: 50%;
  margin-top: 0 !important;
  height: 70%;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  transform: translate(-50%, -50%);
}
.imgPreview .el-dialog__body {
  height: calc(100% - 85px);
  text-align: center;
}
.all-status {
  /* text-align: end; */
  height: 43px;
  padding-top: 15px;
  float: left;
}

.all-right {
  text-align: end;
  height: 43px;
  padding-top: 15px;
  float: left;
  margin-right: 10px;
  margin-left: 200px;
}

.all-clear {
  clear: both;
}

.hide .el-upload--picture-card {
  display: none;
}
</style>